import { useEffect, useState } from "react";
import { api, formatR } from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState(null);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setCustomers(r.data.customers)).catch(() => setCustomers([]));
  }, []);

  return (
    <div data-testid="admin-customers">
      <h1 className="font-display text-2xl font-bold tracking-tight text-navy mb-1">Customers</h1>
      <p className="text-sm text-slate-500 mb-6">Registered customer accounts and their lifetime spend. Employee console accounts are managed under Settings → Employee accounts.</p>

      {!customers ? (
        <div className="h-40 bg-white rounded-2xl border border-slate-100 animate-pulse" />
      ) : customers.length === 0 ? (
        <div className="bg-white rounded-3xl border border-slate-200/80 p-12 text-center text-sm text-slate-500" data-testid="no-customers">
          No registered customers yet. Guest checkouts don't create accounts.
        </div>
      ) : (
        <div className="bg-white rounded-3xl border border-slate-200/80 overflow-x-auto">
          <table className="w-full text-sm min-w-[560px]" data-testid="customers-table">
            <thead>
              <tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-100">
                <th className="px-5 py-3">Customer</th>
                <th className="px-5 py-3">Joined</th>
                <th className="px-5 py-3">Orders</th>
                <th className="px-5 py-3">Total spent</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} className="border-b border-slate-50 hover:bg-cream/50" data-testid={`customer-row-${c.id}`}>
                  <td className="px-5 py-3">
                    <p className="font-semibold text-navy">
                      {c.name}
                      {c.role === "admin" && (
                        <span className="ml-2 text-[9px] font-bold uppercase tracking-wider bg-navy text-gold px-2 py-0.5 rounded-full">Admin</span>
                      )}
                    </p>
                    <p className="text-xs text-slate-400">{c.email}</p>
                  </td>
                  <td className="px-5 py-3 text-slate-600">
                    {new Date(c.created_at).toLocaleDateString("en-ZA", { day: "numeric", month: "short", year: "numeric" })}
                  </td>
                  <td className="px-5 py-3 font-mono">{c.order_count}</td>
                  <td className="px-5 py-3 font-mono font-bold text-navy">{formatR(c.total_spent)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
